import React from "react";
import { Avatar } from "antd";
import { EditOutlined } from "@ant-design/icons";

const getInitials = (name) => {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/);
  const last = parts[parts.length - 1];
  return (last[0] || "?").toUpperCase();
};

const PersonChip = ({ name, isOwner = false, size = "small" }) => {
  if (!name) return null;
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        whiteSpace: "nowrap",
      }}
    >
      <Avatar
        size={size}
        style={{
          backgroundColor: isOwner ? "var(--color-primary)" : "#87d068",
          color: "#fff",
          flexShrink: 0,
        }}
      >
        {getInitials(name)}
      </Avatar>
      <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
        {name}
        {isOwner && (
          <EditOutlined
            style={{ color: "var(--color-primary)", fontSize: 11 }}
          />
        )}
      </span>
    </span>
  );
};

export default PersonChip;
